import getNested from 'lodash-es/get'
import Vue from 'vue'
import Vuex from 'vuex'
import sortBy from "lodash-es/sortBy";


Vue.use(Vuex);

const baseUrl = 'https://commodity-classifier-espv2-xeathecueq-lz.a.run.app/v1';

export default {
  namespaced: true,
  modules: {
    // polygons: PolygonsStore,
  },

  state: () => {
    return {
      commodities: null,
    };
  },


  mutations: {
    setStateValue(state, {name, value}) {
      state[name] = value;
    },
  },

  actions: {
    async predictIronOre({dispatch}, parameters) {
      let response = await dispatch(
        'apiRequest',
        {
          method: 'get',
          path: '/predict',
          data: parameters,
        }
      );

      return response.data;
    },

    async apiRequest(store, parameters) {
      // here you can override common API request parameters for this api module
      // for example:
      // parameters: {...parameters, baseUrl: process.env.VUE_APP_BETA_API_URL},
      return store.dispatch(
        'apiRequest',
        {...parameters, baseUrl},
        { root: true },
      );
    },
  }
}
